import { OssCdnAliyunGuide } from '@/components/OssCdnAliyunGuide';
import { Button } from '@/components/ui/Button';

/** 独立小窗页面：OSS/CDN 阿里云开通指引（由设置页弹出） */
export function OssCdnAliyunGuidePage() {
  return (
    <div className="min-h-screen bg-app-mesh">
      <header className="sticky top-0 z-10 border-b border-slate-200/80 bg-white/90 px-4 py-3 shadow-sm backdrop-blur-md sm:px-6">
        <div className="mx-auto flex max-w-4xl items-center justify-between gap-3">
          <div className="min-w-0">
            <p className="text-[11px] font-semibold uppercase tracking-wide text-teal-700/90">贴图虾</p>
            <h1 className="truncate text-lg font-bold text-slate-900 sm:text-xl">开通指引 · 阿里云 OSS</h1>
          </div>
          <Button
            type="button"
            variant="secondary"
            className="shrink-0"
            onClick={() => {
              window.close();
            }}
          >
            关闭窗口
          </Button>
        </div>
      </header>
      <main className="mx-auto max-w-4xl space-y-6 px-4 py-5 sm:px-6 sm:py-6">
        <OssCdnAliyunGuide />
        <p className="pb-4 text-center text-xs text-slate-500">
          配置完成后请回到「OSS 参数设置」页保存并测试连接。可关闭本窗口。
        </p>
      </main>
    </div>
  );
}
